// Черновите на „Прехвърляне" на началния екран и на таблото — общото
// `components/drafts/useHomeDrafts` с думите и картата на прехвърлянето:
// моето незавършено (от сървъра, а до BE без черновите — локалното в този
// браузър) и тези на колегите; заето → „Поеми редакцията".
import { useWarehouses } from "../../../../../hooks/useInventory";
import { useHomeDrafts } from "../../../components/drafts/useHomeDrafts";
import { DRAFT_TEXTS } from "../../../components/drafts/draftTexts";
import { TRANSFER_DRAFT_STORE, localTransferDraftSummary } from "../transferDraft";

export const TRANSFER_NEW_PATH = "/inventory/transfer/new";

export const useTransferHomeDrafts = () => {
  const { data: warehouses = [] } = useWarehouses();
  return useHomeDrafts({
    type: "transfer",
    newPath: TRANSFER_NEW_PATH,
    local: TRANSFER_DRAFT_STORE,
    localSummary: (draft) =>
      localTransferDraftSummary(
        draft,
        (warehouseId) => warehouses.find((warehouse) => warehouse.id === warehouseId)?.name ?? null,
      ),
    texts: DRAFT_TEXTS.transfer,
  });
};
